// Parses the additionalInfo JSON string stored on a "my books" activity.
// The book viewer writes the chapter title into that JSON verbatim, so a title such as ט"ו בשבט
// produces an unescaped double quote and JSON.parse throws. This helper repairs that case and never
// throws: it returns null when the payload is missing or cannot be recovered.

// Captures the currentChapter value up to the quote that closes it (followed by the next key or the end of the object).
const CURRENT_CHAPTER_VALUE = /("currentChapter"\s*:\s*")([\s\S]*?)("\s*(?:,\s*"|\}))/;

const escapeQuotesInCurrentChapter = raw =>
  raw.replace(CURRENT_CHAPTER_VALUE, (match, prefix, chapter, suffix) => `${prefix}${chapter.replace(/\\?"/g, '\\"')}${suffix}`);

export const parseAdditionalInfo = raw => {
  if (typeof raw !== 'string' || raw.trim() === '') {
    return null;
  }

  try {
    return JSON.parse(raw);
  } catch (parseError) {
    try {
      return JSON.parse(escapeQuotesInCurrentChapter(raw));
    } catch (repairError) {
      console.error('Could not parse book additionalInfo:', raw, repairError);
      return null;
    }
  }
};
